import React from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'

export class Calendar extends React.Component {
  static get propTypes () {
    return {
      focusDate: PropTypes.object,
      selected: PropTypes.object,
      handleDateSelect: PropTypes.func
    }
  }

  constructor (props) {
    super(props)

    this.state = {
      focusDate : this.props.focusDate
    }
  }

  handleNextMonth () {
    this.setState({
      focusDate : moment(this.state.focusDate).add(1, "months")
    })
  }

  handlePrevMonth () {
    this.setState({
      focusDate : moment(this.state.focusDate).subtract(1, "months")
    })
  }

  handleDateSelect (date) {
    jQuery(".fdn-calendar-dropdown-block").each((i, el) => {
      /*global UIkit*/
      UIkit.dropdown(el).hide();
    })
    this.props.handleDateSelect(date)
  }

  getMonth () {
    var focusDate = moment(this.state.focusDate)
    var firstDayInMonth = moment(focusDate).startOf('month')
    var startOfCal = moment(firstDayInMonth).startOf('week')
    var startOfWeek = moment(startOfCal)
    var monthData = []

    var guard = 0
    while ( guard === 0 || startOfWeek.format('M') === focusDate.format('M')) {
      let weekData = []
      var currentDate = moment(startOfWeek)

      for ( var i = 0; i < 7 ; i++) {
        weekData.push(currentDate)
        currentDate = moment(currentDate).add(1, "d")
      }
      monthData.push(weekData)
      startOfWeek = moment(startOfWeek).add(7, "d")
      guard++
      if (guard > 10) {
        break;
      }
    }

    return monthData
  }

  isSelected (day) {
    if (this.props.selected) {
      var selected = moment(this.props.selected)
      return day.format("YMD") === selected.format("YMD")
    }
    return false
  }

  render () {
    var month = this.getMonth()
    var focusDate = moment(this.state.focusDate)

    // if month is this month we are at the earliest
    var atEarliestMonth = focusDate.format("YYYY-M") === moment().format("YYYY-M")
    return (

      <div className="">
        <div className="uk-flex uk-flex-middle fdn-calendar-header-block">
          { 
            atEarliestMonth 
              ?
              <div className="fdn-calendar-prev-next uk-disabled">
                <span uk-icon="chevron-left"></span>
                <span className="fdn-calendar-prev-next-text">
                  prev
                </span>
              </div>
              :
              <div onClick={this.handlePrevMonth.bind(this)} className="fdn-calendar-prev-next">
                <span uk-icon="chevron-left"></span>
                <span className="fdn-calendar-prev-next-text">
                  prev
                </span>
              </div>
          }
          <div className="uk-text-center uk-flex-1 fdn-calendar-month-text">
            {focusDate.format("MMMM")}
          </div>
          <div onClick={this.handleNextMonth.bind(this)} className="fdn-calendar-prev-next">
            <span className="fdn-calendar-prev-next-text">
              next
            </span>
            <span uk-icon="chevron-right"></span>
          </div>
        </div>

        <div className="cal-body">
          <div className="uk-flex uk-flex-middle cal-header">
            {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map( (d, i) => {
              return (<div className="uk-flex-1 fdn-calendar-day-label" key={`cal-lable-${d}-${i}`}>{d}</div>)
            })}
          </div>
          { month.map((week, i) => {
            return (
              <div className="uk-flex uk-flex-middle" key={`cal-week-${i}`}>
                { week.map((day, i) => {
                  return (
                    <CalendarDay 
                      key={`cal-day-${i}`}
                      focused={day.format("M") === focusDate.format("M")}
                      selected={this.isSelected(day)}
                      handleClick={() => {this.handleDateSelect(day)}}
                      date={day}
                    />
                  )
                })}
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}



export class RangeCalendar extends React.Component {
  static get propTypes () {
    return {
      focusDate: PropTypes.object,
      toDate: PropTypes.object,
      fromDate: PropTypes.object,
      handleToSelect: PropTypes.func, 
      handleFromSelect: PropTypes.func, 
      selecting: PropTypes.string,
    }
  }

  constructor (props) {
    super(props)
    this.state = {
      focusDate : this.props.focusDate
    }
  }

  handleNextMonth () {
    this.setState({
      focusDate : moment(this.state.focusDate).add(1, "months")
    })
  }

  handlePrevMonth () {
    this.setState({
      focusDate : moment(this.state.focusDate).subtract(1, "months")
    })
  }

  handleDateSelect (date) {
    jQuery(".fdn-calendar-dropdown-block").each((i, el) => {
      UIkit.dropdown(el).hide();
    })
    var selecting = this.props.selecting
    if (selecting === "to") {
      if (date.isBefore(this.props.fromDate)) {
        this.props.handleFromSelect(date)
        this.props.handleToSelect(this.props.toDate || this.props.fromDate)
      } 
      else {
        this.props.handleToSelect(date)
      }
    } 
    else {
      if ( this.props.toDate && date.isAfter(this.props.toDate) ) {
        this.props.handleToSelect(date)
      } 
      else {
        this.props.handleFromSelect(date)
      }
    }
  }

  handleToSelect (date) {
    // hacketey hack hack
    jQuery(".fdn-calendar-dropdown-block").each((i, el) => {
      UIkit.dropdown(el).hide();
    })
    this.props.handleToSelect(date)
  }

  getMonth () {
    var focusDate = moment(this.state.focusDate)
    var firstDayInMonth = moment(focusDate).startOf('month')
    var startOfCal = moment(firstDayInMonth).startOf('week')
    var startOfWeek = moment(startOfCal)
    var monthData = []

    var guard = 0
    while ( guard === 0 || startOfWeek.format('M') === focusDate.format('M')) {
      let weekData = []
      var currentDate = moment(startOfWeek)

      for ( var i = 0; i < 7 ; i++) {
        weekData.push(currentDate)
        currentDate = moment(currentDate).add(1, "d")
      }
      monthData.push(weekData)
      startOfWeek = moment(startOfWeek).add(7, "d")
      guard++
      if (guard > 10) {
        break;
      }
    }

    return monthData
  }

  isSelected (day) {
    if (this.props.toDate && day.format("YMD") === this.props.toDate.format("YMD") ) {
      return true
    }

    if (this.props.fromDate && day.format("YMD") === this.props.fromDate.format("YMD")) {
      return true
    }
    return false
  }


  isRangeSelected (day) {
    if (this.props.toDate && this.props.fromDate) {
      if (day.isBefore(this.props.toDate) && day.isAfter(this.props.fromDate)) {
        return true
      }
    }
    return false
  }

  render () {
    var month = this.getMonth()
    var focusDate = moment(this.state.focusDate)

    var atEarliestMonth = focusDate.format("YYYY-M") === moment().format("YYYY-M")
    return (

      <div className="" styles={{"height":"12.5rem"}}>
        <div className="fdn-calendar-header-block uk-flex uk-flex-middle">
          { 
            atEarliestMonth 
              ?
              <div className="fdn-calendar-prev-next uk-disabled">
                <span uk-icon="chevron-left"></span>
                <span className="fdn-calendar-prev-next-text">
                  prev
                </span>
              </div>
              :
              <div onClick={this.handlePrevMonth.bind(this)} className="fdn-calendar-prev-next">
                <span uk-icon="chevron-left"></span>
                <span className="fdn-calendar-prev-next-text">
                  prev
                </span>
              </div>
          }
          <div className="uk-flex-1 uk-text-center fdn-calendar-month-text">
            {focusDate.format("MMMM")}
          </div>

          <div onClick={this.handleNextMonth.bind(this)} className="fdn-calendar-prev-next">
            <span className="fdn-calendar-prev-next-text">
              next
            </span>
            <span uk-icon="chevron-right"></span>
          </div>
        </div>

        <div className="cal-body">
          <div className="uk-flex uk-flex-middle cal-header">
            {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map( (d, i) => {
              return (<div className="uk-flex-1 fdn-calendar-day-label" key={`cal-lable-${d}-${i}`}>{d}</div>)
            })}
          </div>
          { month.map( week => {
            return (
              <div className="uk-flex uk-flex-middle" key={week}>
                { week.map(day => {
                  return (
                    <CalendarDay 
                      key={day}
                      focused={day.format("M") === focusDate.format("M")}
                      selected={this.isSelected(day)}
                      rangeSelected={this.isRangeSelected(day)}
                      handleClick={() => {this.handleDateSelect(day)}}
                      date={day}
                    />
                  )
                })}
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}

class CalendarDay extends React.Component {
  static get propTypes () {
    return {
      date : PropTypes.object,
      focused: PropTypes.bool,
      selected: PropTypes.bool,
      rangeSelected: PropTypes.bool,
      handleClick: PropTypes.func, 
    }
  }

  handleClick () {
    var date = moment(this.props.date)
    if (date.endOf('day').isBefore(moment())) {
      return false;
    }

    this.props.handleClick(this.props.date)
  }

  render () {
    var date = moment(this.props.date)
    var classes = [
      "fdn-calendar-day uk-flex-1",
      this.props.focused ? "focused" : "uk-disabled",
      this.props.selected ?  "uk-active" : "",
      this.props.rangeSelected ? "range-selected" : "",
      date.isBefore(moment().subtract(1, "d")) ? "uk-disabled" : "",
    ].join(" ")

    return (
      <div onClick={this.handleClick.bind(this)}
        className={classes}>
        {this.props.date.format("D")}
      </div>
    )
  }
}

